<template>
  <!-- 图片放大弹窗 -->
  <div class="showBigImg">
    <k-dialog
      :class="{'showBigImgModal': !isPdf, 'showBigPdfModal':isPdf}" 
      ref = "showBigImgDialog"
      :options = "{title: title, center:true,width: '80%',height:900,top:'0',destroyOnClose:true,
      isCanClickClose: '!isPdf',showClose: '!isQuickCollectFlag',
      onCloseBefore: cancelBigImg,
      appendToBody:false}">
      <div class="pdfContent" v-if="isPdf">
        <vuePdf :pdfurl="fileSrc" @pdferr="pdferr" @closePdf="closePdf" :fileName="title"></vuePdf>
      </div>
      <img v-else  style="max-width: 100%; display: block; margin: 0.16rem auto" :src="fileSrc" />
    </k-dialog>
  </div>
</template>

<script>
import vuePdf from "@/components/common/vue-pdf.vue";
import kDialog from "../../common/dialog.vue";

export default {
  components: {
    kDialog,
    vuePdf
  },
  props: ["title", "fileSrc", "isPdf", "index"],
  data () {
    return {
      // isShow: true,
    };
  },
  watch: {
    // isShowBigImg (newVal) {
    //   console.log("'newValnewValnewValnewVal'",newVal);
    //   if(newVal){
    //     this.$refs.showBigImgDialog.open();
    //   }
    // }
    // isShowBigImg: {
    //   handler (newVal) {
    //     console.log("'newValnewValnewValnewVal'",newVal);
    //     this.isShow = newVal;
    //     if(newVal){
    //       this.$refs.showBigImgDialog&& this.$refs.showBigImgDialog.open();
    //     }else{
    //       // this.$refs.uploadDialog.close();
    //     }
    //   },
    //   immediate: true
    // }
  },
  computed: {},
  async created () {},
  mounted () {
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
    });
    this.$refs.showBigImgDialog.open();
  },
  beforeRouteLeave (to, from, next) {},
  beforeDestroy () {
    this.$nextTick(() => {
      // 打开右键
      document.oncontextmenu = new Function("event.returnValue=true");
    });
  },
  methods: {
    async cancelBigImg () {
      this.$emit("cancelBigImg");
    },
    pdferr () {
      consoleLog("pdf加载失败");
      this.alert("pdf加载失败");
    },
    closePdf (){
      this.$emit("cancelBigImg");
    }
  }
};
</script>

<style>
.showBigImgModal .ivu-modal-body {
  text-align: center;
  height: 8rem;
}
.showBigImgModal .ivu-modal-body img {
  max-height: 7.5rem;
}
.showBigPdfModal .ivu-modal-body {
  text-align: center;
  height: 9rem;
}
@media screen and (max-width: 1440px) {
  .uploadBox .uploadModel .ivu-modal {
    width: 10.1rem !important;
  }
}

</style>
<style scoped>
.showBigImg {
  background: rgba(55,55,55,.6);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 2999;
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/showBigImg.vue